import React from "react";
import { Content } from './styles'

interface Props{
    title: string;
    type: 'ACTIVE' | 'INACTIVE' | 'PENDING'
}
export function Status({ title, type, ...rest } : Props){
    return(
        <Content  { ...rest} type={type}>
                    {title}
        </Content>
    )
}